import MessageService from "@/services/api/MessageService";
import useUsers from "./useUsers";

const useMissions = () => {
  const { selectedUsers, getUsers, usersById } = useUsers();

  const startMission = (mission: MissionType, parameters?: Dic<unknown>) => {
    return new Promise((resolve) => {
      MessageService.startMission(mission, selectedUsers, parameters)
        .then(() => getUsers())
        .then(resolve);
    });
  };

  const startFollowLeaderMission = () => {
    const users = selectedUsers.map((id) => usersById[id]);
    return new Promise((resolve) => {
      Promise.all(
        users.map(async (user) => {
          if (user.leader) {
            MessageService.startMission("TRACE", [user.id]);
          } else {
            MessageService.startMission("FOLLOW_LEADER", [user.id]);
          }
        })
      )
        .then(() => getUsers())
        .then(resolve);
    });
  };

  const stopMission = () => {
    return new Promise((resolve) => {
      MessageService.stopMission(selectedUsers)
        .then(() => getUsers())
        .then(resolve);
    });
  };

  const sendMaskConfig = (config: string, configType: ConfigType, fileName: string) => {
    const userIds = selectedUsers;

    return new Promise((resolve) => {
      MessageService.startMission(configType, userIds, { config, fileName })
        .then(() => getUsers())
        .then(resolve);
    });
  };

  return { startMission, stopMission, startFollowLeaderMission, sendMaskConfig };
};

export default useMissions;
